import { svg } from 'lit';

export const caretDownIcon = svg`
  <path fill-rule="evenodd" clip-rule="evenodd" d="M18.7071 9.70711L12.7071 15.7071C12.3166 16.0976 11.6834 16.0976 11.2929 15.7071L5.29292 9.70711C5.00692 9.42111 4.92137 8.99099 5.07615 8.61732C5.23093 8.24364 5.59557 8 6.00003 8H18C18.4045 8 18.7691 8.24364 18.9239 8.61732C19.0787 8.99099 18.9931 9.42111 18.7071 9.70711Z" fill="currentColor"/>
  `;
